'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  tag: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]),
  top: _react.PropTypes.bool,
  bottom: _react.PropTypes.bool,
  className: _react.PropTypes.any
};

var defaultProps = {
  tag: 'img'
};

var CardImg = function CardImg(props) {
  var className = props.className;
  var top = props.top;
  var bottom = props.bottom;
  var Tag = props.tag;

  var attributes = _objectWithoutProperties(props, ['className', 'top', 'bottom', 'tag']);

  var cardImgClassName = 'card-img';
  if (top) {
    cardImgClassName = 'card-img-top';
  }
  if (bottom) {
    cardImgClassName = 'card-img-bottom';
  }

  var classes = (0, _classnames2.default)(className, cardImgClassName);

  return _react2.default.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardImg.propTypes = propTypes;
CardImg.defaultProps = defaultProps;

exports.default = CardImg;


/*****************
 ** WEBPACK FOOTER
 ** ./~/reactstrap/lib/CardImg.js
 ** module id = 161
 ** module chunks = 0
 **/